import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { ArrowIcon, Button as Button95, Hourglass, NumberInput, Panel, TextInput } from 'react95-native-rabbl';
import Head from 'expo-router/head';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import { useForm, Controller } from "react-hook-form";
import { AppContext } from '@/components/AppContext';
import { RelativePathString, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import * as AppConsts from '@/utilities/AppConsts';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  formElement: {
    width: '100%',
  },
  inputWrapper: {
    gap: 10,
    alignItems: 'center',
    width: '100%',
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
  panel: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  numericWrapper: {
    flexDirection: 'row',
    gap: 5,
  },
  numeric: {
    width: 80,
  },
  textWrapper: {
    flexDirection: 'row',
    alignSelf: 'center',
    paddingTop: 20,
  }
});

export default function CancelJoin() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    try {
      showSpinner();

      const response = await AppUtilities.fetchAuthorized(
        "CancelJoin.onSubmit",
        "/rabbl/api/canceljoin",
        "POST",
        {
          domain: domain,
        }
      );
      await AppUtils.logout(dispatch, showSpinner, hideSpinner);
      router.replace(AppConsts.SUBDOMAIN_HOMEPAGE_LOGGED_OUT as RelativePathString);

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "CancelJoin.onSubmit");
    } finally {
      hideSpinner();
    }
  }, [domain]);

  return (
    <View style={styles.textWrapper}>
      <Pressable
        onPress={
          () => AppUtils.showDialog(
                  "Cancel joining this Rabbl?",
                  onSubmit,
                  "Cancel Joining",
                  "Nevermind",
                )
        }
      >
        <CustomText type="link">cancel</CustomText>
      </Pressable>
    </View>
  );
}
